import _ from 'lodash';

import { IS_HEADER_ENABLED_PATH } from '../constants/wix-params';
import { EXPERIMENT_HEADER_TOGGLE } from '../constants/experiments';
import { isExperimentEnabled } from '../../app/selectors/experiments-selectors';

export const getAppSettings = state => state.appSettings;

export const getAppSettingsValue = ({ state, key, fallback }) => _.get(getAppSettings(state), key, fallback);

export const getStyle = state => _.get(getAppSettings(state), 'style', {});
export const getStyleSetting = (state, path) => _.get(getAppSettings(state), path);

export const getForumData = state => _.get(getAppSettings(state), 'data.forum', {});

export const getSiteColors = state =>
  _.reduce(
    getAppSettings(state).colorPresets,
    (acc, { reference, value }) => {
      acc[reference] = value;
      return acc;
    },
    {}
  );

const isHeaderToggleExperimentEnabled = state =>
  isExperimentEnabled(state, EXPERIMENT_HEADER_TOGGLE);

export const getIsHeaderEnabled = state => {
  if (!isHeaderToggleExperimentEnabled(state)) {
    return true;
  }
  return getAppSettingsValue({ state, key: IS_HEADER_ENABLED_PATH, fallback: true });
};



// WEBPACK FOOTER //
// ./app/selectors/app-settings-selectors.js